export default "__VITE_ASSET__025fb259__"